/**
 * Pushes an event object to the Google Tag Manager dataLayer.
 * @param eventData - An object containing the data to be pushed.
 */
export function pushToDataLayer(eventData: Record<string, unknown>): void {
  // Check if dataLayer was initialized
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    window.dataLayer.push(eventData)
  } else {
    console.warn('GTM dataLayer is not available.')
  }
}

// Define a type for your product data to ensure consistency
interface ProductEventData {
  modelId: string
  brand: string
  model: string
  // Add other relevant properties like price, category, etc.
  // value?: number;
  // currency?: string;
}

/**
 * Tracks an 'AddToCart' event with Meta Pixel (Facebook).
 * @param product - The product object that was added to the cart.
 */
export function fbAddToCartEvent(product: ProductEventData): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_ids: [product.modelId],
      content_name: `${product.brand} ${product.model}`,
      // You can add more standard parameters here
      // value: product.value,
      // currency: 'GBP',
    })
  } else {
    console.warn('Facebook Pixel (fbq) is not available.')
  }
}

/**
 * Tracks a 'Lead' event with Meta Pixel (Facebook).
 * This is typically used after a form submission.
 */
export function fbLeadEvent(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead')
  } else {
    console.warn('Facebook Pixel (fbq) is not available.')
  }
}
